import { getImage, ImageDataLike } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";
import React from "react";
import BackgroundImage from "gatsby-background-image";
import InternalLink from "../InternalLink";
import { EmbeddedAsset } from "../../../graphql-types";
import "./promoBanner.css";

export type PromoBannerProps = {
  heading: string;
  copy: string;
  contentLink: [{ fields: { url: string; title: string } }];
  asset: EmbeddedAsset;
  promoBannerClassName: string;
};

const PromoBanner = ({
  heading,
  copy,
  contentLink,
  asset,
  promoBannerClassName,
}: PromoBannerProps) => {
  const bgImage = asset
    ? convertToBgImage(
        getImage(asset.file.fileLocal as unknown as ImageDataLike)
      )
    : asset;
  return (
    <aside className={`promo-banner ${promoBannerClassName}`}>
      <h2>{heading}</h2>
      <div>
        <p>{copy}</p>
        {asset && (
          <BackgroundImage
            Tag="div"
            {...bgImage}
            alt={asset.description || ""}
            className="promo-background"
            fadeIn={false}
          >
            {contentLink.map((el) => {
              return (
                <InternalLink key={el.fields.title} href={el.fields.url}>
                  {el.fields.title}
                </InternalLink>
              );
            })}
          </BackgroundImage>
        )}
      </div>
    </aside>
  );
};

export default PromoBanner;
